import React, { useState, useEffect, useMemo, useRef } from 'react';
import Button from '../ui/button';
import { createPortal } from 'react-dom';
import { Sparkles, Plus, Minus } from 'lucide-react';
import { motion } from 'framer-motion';
import ItemCustomization from './ItemCustomization';
import SearchBar from "../ui/searchBar";
import CategoryList from '../ui/CategoryList';
import { filterCategoriesByTime, filterCategoriesByMenu } from "../../utils/categoryUtils"
export default function MenuBrowser({ categories, menuItems, cart, cartCount, onAddToCart, onRemoveFromCart, onReset, customizingItem, setCustomizingItem, cancelSource, setCancelSource, onCheckout }) {
  //const [selectedCategory, setSelectedCategory] = useState(null);
  //const [customizingItem, setCustomizingItem] = useState(null);

  // filter available categories 
  const availableCategories = filterCategoriesByMenu(filterCategoriesByTime(categories), menuItems);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(availableCategories[0]?.category_id || null);
  // search constants
  const [searchTerm, setSearchTerm] = useState('');
  const searchBarRef = useRef(null);
  // move category ref
  const categoryRefs = useRef({});
  // derive displayed items based on search term and selected category
  const displayedItems = useMemo(() => {
    const q = (searchTerm || '').trim().toLowerCase();
    const activeCategory = selectedCategory || availableCategories[0]?.category_id;
    // console.log("ACTIVECAT", activeCategory);
    if (q.length > 0) {
      return menuItems.filter((item) =>
        (item.menu_item_name || '').toLowerCase().includes(q)
      );
    }
    return menuItems.filter((item) => item.category_id === activeCategory);
  }, [menuItems, selectedCategory, categories, searchTerm]);
  // move category scroller 
  useEffect(() => {
    if (selectedCategory && categoryRefs.current[selectedCategory]) {
      categoryRefs.current[selectedCategory].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, [selectedCategory]);

  const toTitleCase = (str = "") => {
    return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  const handleSearch = (query) => {
    setSearchTerm(toTitleCase(query));
  };
  const handleItemClick = (item) => {
    setCustomizingItem(item);
  };

  const handleCustomizationComplete = (item, customizations, qty, instructions) => {
    searchBarRef.current?.clearSearch()
    //const customizationPrice = customizations.reduce((sum, c) => sum + (parseFloat(c.price * c.qty) || 0), 0);
    const customizationPrice = customizations.reduce((sum, c) => {
      const parentQty = c.qty || 1;

      // parent price
      let total = (parseFloat(c.price) || 0) * parentQty;

      // sub modifiers
      if (Array.isArray(c.subModifiers)) {
        total += c.subModifiers.reduce((subSum, s) => {
          const subQty = s.qty || 1;
          return subSum + (parseFloat(s.price) || 0) * subQty * parentQty;
        }, 0);
      }

      return sum + total;
    }, 0);

    onAddToCart({
      item_id: item.menu_id,
      item_category_id: item.category_id,
      item_name: item.menu_item_name,
      item_image: item.menu_item_image,
      item_base_price: item.menu_item_price,
      price: (parseFloat(item.menu_item_price) + customizationPrice),
      quantity: qty,
      instructions: instructions,
      customizations
    });
    setCustomizingItem(null);
    //setSearchTerm("")
  };
  // add item directly on plus icon click
  const handleAddToCart = (item, qty = 1, instructions = "") => {
    console.log("Adding to cart:", item);
    onAddToCart({
      item_id: item.menu_id,
      item_category_id: item.category_id,
      item_name: item.menu_item_name,
      item_image: item.menu_item_image,
      item_base_price: item.menu_item_price,
      price: (parseFloat(item.menu_item_price)) * qty,
      quantity: qty,
      instructions: instructions,
    });
  };

  // Helper to get total quantity of an item in the cart
  const getItemQuantity = (itemId) => {
    return cart.filter(item => item.item_id === itemId)
      .reduce((total, item) => total + item.quantity, 0);
  };

  // if (customizingItem) {
  //   return (
  //     <ItemCustomization
  //       item={customizingItem}
  //       onComplete={handleCustomizationComplete}
  //       onCancel={() => setCustomizingItem(null)}
  //     />
  //   );
  // }


  return (
    <>
      <div className="flex-1 flex flex-col overflow-hidden bg-white to-white p-6">
        {/* Header */}
        <div className="md:h-[100px] h-[60px] bg-boonsgray backdrop-blur-lg border-b p-3  flex  items-center gap-2 ">
          <div className="flex-shrink-0">
            <Button
              variant="default"
              size="back"
              onClick={() => {
                setCancelSource("back");
                onReset()
              }}
              className=" bg-black"
            >
              <img src="/images/back.png" alt="back" className=" md:w-[80px] md:h-[80px] sm:w-[60px] sm:h-[60px] w-[40px] h-[40px] rounded-[12px]" />
            </Button>
          </div>
          <div className="flex w-full h-full pl-0 pr-0">
            <SearchBar ref={searchBarRef} value={searchTerm || " "} onSearch={handleSearch} />
          </div>
          <div className="flex-shrink-0 h-full">
            <Button
              variant="orange"
              size="custom"
              disabled={cartCount === 0}
              onClick={() => {
                onCheckout();
              }}
              className={`lg:w-[310px] md:w-[190px] w-[120px]
      text-white text-left font-outfit font-medium rounded-lg
      ${cartCount === 0 ? "opacity-50 cursor-not-allowed" : ""}
      ${cartCount > 0 ? "lg:pr-[50px]" : ""}
    `}
            >
              Checkou<span className="relative inline-block">
                t
                {cartCount > 0 &&
                  <span
                    className="lg:ml-2 w-fit absolute lg:top-2 lg:left-[39px] lg:-translate-x-[30%] md:top-2 md:left-[19px] md:-translate-x-[30%] sm:top-0 sm:left-[19px] sm:-translate-x-[30%] top-0 left-[13px] -translate-x-[30%]
           md:bg-white md:text-black bg-white text-black rounded-full
           md:text-[20px] sm:text-[8px] text-[6px] md:px-2 md:py-1 lg:px-5 lg:py-4 sm:px-0 sm:py-2 px-2 py-2 leading-none font-outfit font-bold"
                  >
                    {cartCount}
                  </span>
                }
              </span>
            </Button>
          </div>
        </div>



        { /* Categories - Horizontal Scroll */}
        {(!searchTerm || !searchTerm.trim()) && (
          <div className="bg-white border-b border-gray-200 p-6 lg:h-[110px] md:h-[100px] sm:h-[80px] h-[60px]">
            <div className="flex items-center gap-8">
              <img src="/images/hamburger.png" className="lg:w-8 lg:h-8 md:w-6 md:h-6 w-4 h-4 flex-shrink-0 cursor-pointer" onClick={() => setIsCategoryOpen(true)} />
              <div className="flex overflow-x-auto scrollbar gap-3">
                {availableCategories.map((category, idx) => {
                  const isActive = selectedCategory === category.category_id;
                  // console.log('Active Category inside map:', selectedCategory);
                  return (
                    <motion.button
                      key={category.category_id}
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: idx * 0.05 }}
                      ref={(el) => (categoryRefs.current[category.category_id] = el)}
                      onClick={() => setSelectedCategory(category.category_id)}
                      className={`md:rounded-xl rounded-[5px] relative lg:px-8 lg:py-3 md:px-6 md:py-2 sm:px-4 sm:py-1 px-2 py-1 lg:text-[20px] md:text-[16px] sm:text-[12px] text-[8px] font-outfit font-medium whitespace-nowrap transition-all duration-300 ${isActive
                        ? 'bg-boonsOrange text-white'
                        : 'bg-white text-[#181c2e] border-2 border-gray-200'
                        }`}

                    >
                      {/* {isActive && (
                  <>
                  <div
                    layoutId="activeCategory"
                    className="absolute inset-0 bg-boonscategorybg rounded-2xl"
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                  />
                   {/* underline */}
                      {/*  <div
                layoutId="activeUnderline"
                className="absolute bottom-0 left-0 right-0 h-[8px] bg-boonsOrange"
                transition={{ type: 'spring', stiffness: 300, damping: 25 }}
              />
                  </>
                )} */}
                      <span className="text-2xl relative flex items-center font-outfit font-semibold gap-2">
                        {toTitleCase(category.category_name)}
                        {isActive}
                      </span>
                    </motion.button>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {isCategoryOpen &&
          <div className="">
            <CategoryList
              isOpen={isCategoryOpen}
              categories={availableCategories}
              selectedCategory={selectedCategory}
              onSelect={(id) => setSelectedCategory(id)}
              onClose={() => setIsCategoryOpen(false)}
            />
          </div>
        }

        {/* Menu Items Grid */}
        <div className="flex-1 overflow-y-auto p-4 lg:p-6 bg-white">
          {displayedItems.length > 0 ? (
            <div className="grid xs:grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-6 xl:gap-8 auto-rows-fr">
              {/* <AnimatePresence mode="wait"> */}
              {displayedItems.map((item, idx) => (
                <div
                  key={item.menu_id}
                  className="bg-white rounded-2xl group box-border border border-bordergray border-[2px] flex flex-col h-full"
                >
                  {/* Image Container with Overlay */}
                  <div className="overflow-hidden rounded-2xl " onClick={() => handleItemClick(item)}>
                    {item.menu_item_image ? (
                      <div className="aspect-[4/3] w-full mb-3 overflow-hidden rounded-xl">
                        <img
                          src={item.menu_item_image}
                          alt={item.menu_item_name}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                    ) : (
                      <div className="aspect-[4/3] w-full mb-3 bg-gradient-to-br from-orange-100 to-red-100 rounded-xl flex items-center justify-center">
                        <Sparkles className="w-10 h-10 lg:w-16 lg:h-16 text-orange-300 " />
                      </div>
                    )}

                    {/* Quick Add Badge - pinned exactly to the image top-right corner */}
                    {/* <div className="absolute top-0 right-0 w-10 h-10 md:w-14 md:h-14 z-50 pointer-events-auto">
              <img src="/images/addIcon.png" alt="Add" className="w-full h-full object-contain" />
            </div> */}
                  </div>

                  {/* Content */}
                  <div className="flex flex-col flex-grow p-2">
                    <div className="flex-grow pb-3">
                      <span className="text-2xl font-outfit font-medium text-black leading-tight block ">
                        {toTitleCase(item.menu_item_name)}
                      </span>

                      {/* {item.menu_item_description && (
              <p className="text-sm text-gray-600 mb-3 text-left break-words ">
                {item.menu_item_description}
              </p>
            )} */}

                    </div>
                    <div className="border-b-[2px] p-0 border-[#f0f0f0]" />

                    {/* Price and Action */}
                    <div className="border-none mt-3 flex items-start justify-between">
                      <div>
                        <span className="mt-3 lg:text-[24px] md:text-[20px] text-[16px] font-outfit font-semibold text-boonsOrange block">
                          ${item.menu_item_price}
                        </span>
                        <div className='min-h-[32px]'>
                          {item.options && item.options.length > 0 && (
                            <p className="text-l text-textgray font-outfit font-normal mt-1">Customizable</p>
                          )}
                        </div>
                      </div>
                      <div className='flex items-start m-4'>
                        <button
                          onClick={() => {
                            handleItemClick(item);
                          }}
                          className="bg-boonsOrange text-white rounded-full w-auto p-2 flex items-center justify-center shadow-lg "
                        >
                          <img src="/images/plus.png" className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* </AnimatePresence> */}
            </div>
          ) : (
            <>
              {/* Empty State (only when NOT searching) */}
              {!searchTerm && displayedItems.length === 0 && menuItems.length > 0 && (
                <div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="flex flex-col items-center justify-center h-full text-gray-400"
                >
                  <Sparkles className="w-24 h-24 mb-4" />
                  <p className="text-2xl font-semibold">No items in this category</p>
                  <p className="text-lg mt-2">Check out our other delicious options!</p>
                </div>
              )}
              {/* Empty search State */}
              {searchTerm?.trim() !== '' && displayedItems.length === 0 && (

                <div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="flex flex-col items-center justify-center h-full text-gray-400"
                >

                  <img src="/images/noResults.png" alt="not found" className="w-[504px] h-[332px] object-contain" />
                  <p className="text-black text-[48px] font-outfitsemibold">No matching results</p>
                  <button
                    onClick={() => {
                      setSearchTerm('');
                      searchBarRef.current?.clearSearch();
                    }}
                    className="bg-boonsOrange w-[415px] h-[85px] text-white text-[40px] font-outfitsemibold rounded-[40px] px-6 py-3 mt-6"
                  >
                    Return to Menu
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {customizingItem && createPortal(
        <div className="fixed inset-0 z-[10000] bg-white overflow-auto">
          <ItemCustomization
            item={customizingItem}
            onComplete={handleCustomizationComplete}
            onCancel={() => setCustomizingItem(null)}
          />
        </div>,
        document.body
      )}
    </>
  );
}